import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _styled7 from "styled-components";
import _styled6 from "styled-components";
import _styled5 from "styled-components";
import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
import { css as _css } from "styled-components";
var _excluded = ["up"],
  _excluded2 = ["desc"],
  _excluded3 = ["showHeaders"];
import React from "react";
import { Composition, Box, useResponsiveQuery, query } from "atomic-layout";
import { colors } from "../shared/styles";
import { useTable, useSortBy, usePagination, useExpanded, flexRender } from "react-table";
import * as R from "ramda";
import { ArrowUnsorted, ArrowSortedDown, ArrowSortedUp } from "styled-icons/typicons";
import { SelectPlaceholder, UISelect } from "../Input";
import { Pagination, PaginationNav, PaginationItem } from "../Pagination";
import { Icon } from "../Icons";
export var ArrowToggle = React.forwardRef(function (_ref, ref) {
  var up = _ref.up,
    props = _objectWithoutProperties(_ref, _excluded);
  return up ? /*#__PURE__*/React.createElement("span", null, "^") : /*#__PURE__*/React.createElement("span", null, ">");
});
export var SortToggle = React.forwardRef(function (_ref2, ref) {
  var desc = _ref2.desc,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return R.isNil(desc) ? /*#__PURE__*/React.createElement(Icon, Object.assign({
    icon: ArrowUnsorted,
    ref: ref
  }, props)) : desc ? /*#__PURE__*/React.createElement(Icon, Object.assign({
    icon: ArrowSortedDown,
    ref: ref
  }, props)) : /*#__PURE__*/React.createElement(Icon, Object.assign({
    icon: ArrowSortedUp,
    ref: ref
  }, props));
});
var hide = "display: none !important;";
export var TableHeader = function TableHeader(_ref3) {
  var showHeaders = _ref3.showHeaders,
    restProps = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(_StyledBox, Object.assign({}, restProps, {
    $_css2: _css(["display:contents;", " @media ", "{display:none !important;}"], !showHeaders && hide, query({
      to: "lg"
    }))
  }));
};
export var TableHeaderCell = function TableHeaderCell(props) {
  return /*#__PURE__*/React.createElement(_StyledComposition, Object.assign({
    templateCols: "1fr",
    padding: 10,
    paddingLg: 8,
    paddingRight: 8,
    paddingRightLg: 8,
    alignItems: "center"
  }, props, {
    $_css3: colors.grayRegular
  }));
};
var rowHover = _css(["cursor:pointer;&:hover{.row-cell{background:", ";}}"], colors.grayLightest);
export var TableRow = function TableRow(props) {
  return /*#__PURE__*/React.createElement(_StyledBox2, Object.assign({}, props, {
    $_css4: colors.secondaryGray
  }));
};
var _StyledTableRow = _styled(TableRow).withConfig({
  displayName: "Table___StyledTableRow",
  componentId: "sc-b1sgpy-0"
})(["", ""], function (p) {
  return p.$_css6;
});
var sizes = ["Xs", "Sm", "Md", "Lg", "Xl"];
export var TableRowCell = function TableRowCell(props) {
  return /*#__PURE__*/React.createElement(_StyledComposition2, Object.assign({
    className: "row-cell",
    alignItems: "center",
    padding: 10,
    paddingLg: 8,
    paddingRightLg: 8
  }, props));
};
export var getDyanmicWidthProps = function getDyanmicWidthProps(props, _ref4) {
  var visibleColumns = _ref4.instance.visibleColumns;
  var templateCols = sizes.reduce(function (acc, size) {
    if (visibleColumns.some(R.prop("width" + size))) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, "templateCols" + size, visibleColumns.map(function (column) {
        var _column;
        return (_column = column === null || column === void 0 ? void 0 : column["width" + size]) !== null && _column !== void 0 ? _column : column.width;
      }).join(" ")));
    }
    return acc;
  }, {
    templateCols: visibleColumns.map(R.prop("width")).join(" ")
  });
  return [props, templateCols];
};
export var stopPropagationToRowClick = function stopPropagationToRowClick(props, _ref5) {
  var row = _ref5.row;
  return [props, {
    onClick: function onClick(event) {
      event.stopPropagation();
      row.toggleRowExpanded();
    }
  }];
};
export var TableRowDetails = function TableRowDetails(props) {
  return /*#__PURE__*/React.createElement(Composition, Object.assign({
    colStart: 1,
    colEnd: -1
  }, props));
};
export var Table = function Table(props) {
  return /*#__PURE__*/React.createElement(_StyledComposition3, Object.assign({
    alignItems: "stretch",
    justifyItems: "stretch",
    autoRows: "auto"
  }, props));
};
export var SortableTableHeaderCell = function SortableTableHeaderCell(props) {
  return /*#__PURE__*/React.createElement(TableHeaderCell, Object.assign({
    templateCols: "1fr 20px"
  }, props));
};
export var SortableTable = function SortableTable(_ref6) {
  var userColumns = _ref6.columns,
    data = _ref6.data,
    showHeadersMobile = _ref6.showHeadersMobile,
    showHeadersTablet = _ref6.showHeadersTablet,
    _ref6$showHeaders = _ref6.showHeaders,
    showHeaders = _ref6$showHeaders === void 0 ? true : _ref6$showHeaders,
    onRowClick = _ref6.onRowClick,
    renderDetails = _ref6.renderDetails,
    initialSortBy = _ref6.initialSortBy;
  var isMobile = useResponsiveQuery({
    to: "md"
  });
  var columns = React.useMemo(function () {
    return R.isNil(renderDetails) ? userColumns : userColumns.concat({
      id: "expander",
      width: "auto",
      mobile: true,
      Header: function Header() {
        return null;
      },
      Cell: function Cell(_ref7) {
        var row = _ref7.row;
        return /*#__PURE__*/React.createElement("span", row.getToggleRowExpandedProps(stopPropagationToRowClick), /*#__PURE__*/React.createElement(ArrowToggle, {
          size: 24,
          color: "primaryBlue",
          up: row.isExpanded
        }));
      }
    });
  }, [renderDetails, userColumns]);
  var emptyArray = React.useMemo(function () {
    return [];
  }, []);
  var instance = useTable({
    columns: columns,
    data: data,
    initialState: {
      hiddenColumns: ["expander"],
      sortBy: initialSortBy !== null && initialSortBy !== void 0 ? initialSortBy : emptyArray
    }
  }, useSortBy, useExpanded, usePagination);
  var getTableProps = instance.getTableProps,
    headerGroups = instance.headerGroups,
    page = instance.page,
    prepareRow = instance.prepareRow,
    allColumns = instance.allColumns,
    toggleSortBy = instance.toggleSortBy,
    pageCount = instance.pageCount,
    canPreviousPage = instance.canPreviousPage,
    canNextPage = instance.canNextPage,
    pageOptions = instance.pageOptions,
    gotoPage = instance.gotoPage,
    nextPage = instance.nextPage,
    previousPage = instance.previousPage,
    setHiddenColumns = instance.setHiddenColumns,
    pageIndex = instance.state.pageIndex;
  React.useEffect(function () {
    if (isMobile) {
      var columnsToHide = columns.filter(function (column) {
        var _column$mobile;
        return !((_column$mobile = column === null || column === void 0 ? void 0 : column.mobile) !== null && _column$mobile !== void 0 ? _column$mobile : true);
      }).map(function (column) {
        var _column$id;
        return (_column$id = column === null || column === void 0 ? void 0 : column.id) !== null && _column$id !== void 0 ? _column$id : column.accessor;
      });
      setHiddenColumns(columnsToHide);
    } else {
      setHiddenColumns(["expander"]);
    }
  }, [columns, isMobile, setHiddenColumns]);
  function handleMobileSort(event) {
    var _String$split = String(event.target.value).split(","),
      _String$split2 = _slicedToArray(_String$split, 2),
      id = _String$split2[0],
      desc = _String$split2[1];
    toggleSortBy(id, desc === "true");
  }
  var sortedColumn = allColumns.find(function (column) {
    return column.isSorted;
  });
  var sortedValue = sortedColumn ? "".concat(sortedColumn.id, ",").concat(sortedColumn.isSortedDesc) : "";
  return /*#__PURE__*/React.createElement(Composition, {
    gap: 8
  }, /*#__PURE__*/React.createElement(_StyledUISelect, {
    onChange: handleMobileSort,
    value: sortedValue,
    $_css5: query({
      from: "lg"
    })
  }, /*#__PURE__*/React.createElement(SelectPlaceholder, null, "-- Sort Data --"), allColumns.map(function (column, i) {
    column.canSort !== false && column.sortOptions.length && column.sortOptions.map(function (option, i) {
      return /*#__PURE__*/React.createElement("option", {
        key: "".concat(column.id, ",").concat(String(i > 0)),
        value: "".concat(column.id, ",").concat(String(i > 0))
      }, R.is(String, column.Header) ? column.Header : column.mobileSortHeader, " ", "(", option, ")");
    });
  })), /*#__PURE__*/React.createElement(Table, getTableProps(getDyanmicWidthProps), headerGroups.map(function (headerGroup) {
    return /*#__PURE__*/React.createElement(TableHeader, Object.assign({}, headerGroup.getHeaderGroupProps(), {
      showHeaders: showHeaders
    }), headerGroup.headers.map(function (column) {
      return /*#__PURE__*/React.createElement(SortableTableHeaderCell, column.getHeaderProps(column.getSortByToggleProps()), /*#__PURE__*/React.createElement(Box, {
        paddingRight: 5,
        paddingRightLg: 8
      }, column.render("Header")), column.canSort !== false && /*#__PURE__*/React.createElement(SortToggle, {
        size: 20,
        color: "secondaryBlueLight",
        desc: column.isSortedDesc
      }));
    }));
  }), page.map(function (row, i) {
    prepareRow(row);
    return /*#__PURE__*/React.createElement(_StyledTableRow, Object.assign({
      key: i
    }, row.getRowProps(), {
      onClick: function onClick(ev) {
        return onRowClick && onRowClick(row.original, ev);
      },
      $_css6: onRowClick && rowHover
    }), row.cells.map(function (cell, key) {
      return /*#__PURE__*/React.createElement(TableRowCell, Object.assign({
        key: key
      }, cell.getCellProps()), cell.render("Cell"));
    }), !R.isNil(renderDetails) && isMobile &&
    // TODO Make better
    row.isExpanded && /*#__PURE__*/React.createElement(TableRowDetails, null, flexRender(renderDetails, {
      row: row,
      instance: instance
    })));
  })), pageCount > 1 && /*#__PURE__*/React.createElement(Pagination, null, /*#__PURE__*/React.createElement(PaginationNav, {
    onClick: function onClick() {
      return previousPage();
    },
    disabled: !canPreviousPage
  }, "Prev"), pageOptions.length > 5 && pageIndex < 4 && /*#__PURE__*/React.createElement(React.Fragment, null, pageOptions.slice(0, 5).map(function (optionIndex, i) {
    return /*#__PURE__*/React.createElement(PaginationItem, {
      key: i,
      onClick: function onClick() {
        return gotoPage(optionIndex);
      },
      selected: pageIndex === optionIndex
    }, optionIndex + 1);
  }), /*#__PURE__*/React.createElement(PaginationItem, {
    ellipsis: true
  }, "..."), /*#__PURE__*/React.createElement(PaginationItem, {
    onClick: function onClick() {
      return gotoPage(pageOptions.length - 1);
    }
  }, pageOptions.length)), pageOptions.length > 5 && pageIndex >= 4 && pageIndex < pageOptions.length - 5 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaginationItem, {
    onClick: function onClick() {
      return gotoPage(0);
    }
  }, "1"), /*#__PURE__*/React.createElement(PaginationItem, {
    ellipsis: true
  }, "..."), pageOptions.slice(pageIndex - 1, pageIndex + 2).map(function (optionIndex, i) {
    return /*#__PURE__*/React.createElement(PaginationItem, {
      key: i,
      onClick: function onClick() {
        return gotoPage(optionIndex);
      },
      selected: pageIndex === optionIndex
    }, optionIndex + 1);
  }), /*#__PURE__*/React.createElement(PaginationItem, {
    ellipsis: true
  }, "..."), /*#__PURE__*/React.createElement(PaginationItem, {
    onClick: function onClick() {
      return gotoPage(pageOptions.length - 1);
    }
  }, pageOptions.length)), pageOptions.length > 5 && pageIndex >= pageOptions.length - 5 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaginationItem, {
    onClick: function onClick() {
      return gotoPage(0);
    }
  }, "1"), /*#__PURE__*/React.createElement(PaginationItem, {
    ellipsis: true
  }, "..."), pageOptions.slice(pageOptions.length - 5, pageOptions.length).map(function (optionIndex, i) {
    return /*#__PURE__*/React.createElement(PaginationItem, {
      key: i,
      onClick: function onClick() {
        return gotoPage(optionIndex);
      },
      selected: pageIndex === optionIndex
    }, optionIndex + 1);
  })), pageOptions.length <= 5 && pageOptions.map(function (optionIndex, i) {
    return /*#__PURE__*/React.createElement(PaginationItem, {
      key: i,
      onClick: function onClick() {
        return gotoPage(optionIndex);
      },
      selected: pageIndex === optionIndex
    }, optionIndex + 1);
  }), /*#__PURE__*/React.createElement(PaginationNav, {
    onClick: function onClick() {
      return nextPage();
    },
    disabled: !canNextPage
  }, "Next")));
};
var _StyledBox = _styled(Box).withConfig({
  displayName: "Table___StyledBox",
  componentId: "sc-b1sgpy-1"
})(["", ""], function (p) {
  return p.$_css2;
});
var _StyledComposition = _styled(Composition).withConfig({
  displayName: "Table___StyledComposition",
  componentId: "sc-b1sgpy-2"
})(["font-weight:600;border-bottom:1px solid ", ";"], function (p) {
  return p.$_css3;
});
var _StyledBox2 = _styled(Box).withConfig({
  displayName: "Table___StyledBox2",
  componentId: "sc-b1sgpy-3"
})(["display:contents;&:nth-of-type(2n + 1){.row-cell{background:", ";}}"], function (p) {
  return p.$_css4;
});
var _StyledComposition2 = _styled(Composition).withConfig({
  displayName: "Table___StyledComposition2",
  componentId: "sc-b1sgpy-4"
})(["border:1px solid transparent;"]);
var _StyledComposition3 = _styled(Composition).withConfig({
  displayName: "Table___StyledComposition3",
  componentId: "sc-b1sgpy-5"
})(["font-weight:400;font-size:12px;"]);
var _StyledUISelect = _styled(UISelect).withConfig({
  displayName: "Table___StyledUISelect",
  componentId: "sc-b1sgpy-6"
})(["@media ", "{display:none !important;}"], function (p) {
  return p.$_css5;
});